import React, { useRef, useLayoutEffect } from 'react'
import ReactDOM from 'react-dom'
import classNames from 'classnames'
import {useKeypress} from "@/Utilities/Hooks";

function onSmallScreen() {
  return window.innerWidth <= 768
}

export function Modal({
  children,
  visible = true,
  setVisible = null,
  onClose = () => {},
  center = false,
  simple = false,
  width = 'md:max-w-3xl',
}) {
  const bodyRef = useRef()
  const scrollTopRef = useRef(null)

  useKeypress('Escape', () => {
    if (!visible || setVisible === null) {
      return;
    }
    setVisible(false);
    onClose();
  }, [visible]);

  function handleOverlayClick(e) {
    if (e.target === bodyRef.current && onClose) {
      e.preventDefault()
      e.stopPropagation()
      onClose()
    }
  }

  function pushScrollY() {
    if (onSmallScreen()) {
      scrollTopRef.current = window.scrollY
      window.scrollTo(window.screenX, 0)
    }
  }

  function popScrollY() {
    if (scrollTopRef.current !== null) {
      window.scrollTo(window.scrollX, scrollTopRef.current)
      scrollTopRef.current = null
    }
  }

  // Fixed modals on mobile don't work very well (body scrolling issues, input focusing etc.),
  // so on mobile we instead hide the root element with .modal-hidden, and show the modal
  // in the document flow. We have to remember the scroll position of the body so that
  // we can restore it when the user exits the modal.
  useLayoutEffect(() => {
    if (visible) {
      pushScrollY()
      document.body.classList.add('modal-open')
      document.body.classList.add('md:overflow-hidden')
    } else {
      document.body.classList.remove('modal-open')
      document.body.classList.remove('md:overflow-hidden')
      popScrollY()
    }
    return () => {
      document.body.classList.remove('modal-open')
      document.body.classList.remove('md:overflow-hidden')
      popScrollY()
    }
  }, [visible])

  let content = simple ? (
    children
  ) : (
    <div
      className={`p-4 md:p-0 mb-16 md:mb-0 ${width} md:max-h-full md:mx-auto md:shadow-modal flex flex-col`}
    >
      {children}
    </div>
  )

  return visible
    ? ReactDOM.createPortal(
        <React.Fragment>
          <div className="inset-0 z-20 bg-black opacity-50 block fixed" />
          <div
            ref={bodyRef}
            onClick={handleOverlayClick}
            className={classNames('fixed inset-0 z-20 md:px-4 md:py-vh-5 overflow-y-scroll', {
              'md:flex md:flex-col md:justify-center md:items-center': center,
            })}
            aria-modal
            aria-hidden
            role="dialog"
          >
            {content}
          </div>
        </React.Fragment>,
        document.body,
      )
    : null
}
